module.exports = __webpack_public_path__ + "img/PersonalPropertyTaxBill.23137101.png";